import { useState } from 'react'

type UsePages = {
    currentPage: number
}

export function usePages({ currentPage }: UsePages) {
    const [activePage, setActivePage] = useState(currentPage)

    const nextPage = () => {
        setActivePage(prev => prev + 1)
    }

    const prevPage = () => {
        setActivePage(prev => prev - 1)
    }

    const reset = () => {
        setActivePage(currentPage)
    }

    const setPage = (step: number) => {
        setActivePage(step)
    }

    return { nextPage, prevPage, reset, setPage, activePage }
}
